/**
 * Created by coolguy on 2017/7/3.
 */
import API from '../util/ApiList';
import Ajax from '../util/ajax.js';
const {
    ajaxCommon
} = Ajax;
const TheApi = API('imagemessage');
const IMAGE_MESSAGE_LIST = "IMAGE_MESSAGE_LIST";
const IMAGE_MESSAGE_ADD = "IMAGE_MESSAGE_ADD";
const IMAGE_MESSAGE_DELETE = "IMAGE_MESSAGE_DELETE";
const IMAGE_MESSAGE_EDIT = "IMAGE_MESSAGE_EDIT";
const IMAGE_MESSAGE_DETAIL = "IMAGE_MESSAGE_DETAIL";

export default {
    IMAGE_MESSAGE_LIST,
    imageMessageList : (search)=>{
        if(typeof search.current != 'undefined') {
            search.page = search.current;
        }
        return ajaxCommon({
            data:search,
            api:TheApi('get')(),
            success: (data)=>({
                type:IMAGE_MESSAGE_LIST,
                data
            })
        })
    },
    IMAGE_MESSAGE_ADD,
    imageMessageAdd : (params)=>{
        return ajaxCommon({
            api:TheApi('post')(),
            data:params,
            success:(data)=>({
                type:IMAGE_MESSAGE_ADD,
                data
            })
        })
    },
    IMAGE_MESSAGE_DELETE,
    imageMessageDelete:(id)=>{
        return ajaxCommon({
            api:TheApi('delete')(id),
            success:(data)=>({
                type:IMAGE_MESSAGE_DELETE,
                data,
            })
        })
    },
    IMAGE_MESSAGE_EDIT,
    imageMessageEdit:(id,info)=>{
        return ajaxCommon({
            api:TheApi('put')(id),
            data:info,
            success:(data)=>({
                type:IMAGE_MESSAGE_EDIT,
                data,
            })
        })
    },
    IMAGE_MESSAGE_DETAIL,
    imageMessageDetail:(id)=>{
        return ajaxCommon({
            api:TheApi('get')(id),
            success:(data)=>({
                type:IMAGE_MESSAGE_DETAIL,
                data,
            })
        })
    },
}



// WEBPACK FOOTER //
// ./src/actions/ImageMessageAction.js